import { Analytics } from '@ht/lib-plural-js';
import useMqtt from '@/composables/useMqtt';

class AnalyticsService extends Analytics {
  constructor() {
    super();

    const { mqttPublish } = useMqtt();
    this.mqttPublish = mqttPublish;
  }

  trackElement(data) {
    const event = this.analyticsEvent(data);
    this.mqttPublish({
      scope: 'robot',
      topic: 'events',
    }, JSON.stringify(event));
  }
}

export default new AnalyticsService();
